import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, Router, NavigationEnd } from '@angular/router';
import { authGuard } from './auth.guard';
import { bulkUploadGuard } from './bulk-upload.guard';
import { bulkUpdateGuard } from './bulk-update.guard';
import { bulkApprovalGuard } from './bulk-approval.guard';
import { preBulkApprovalGuard } from './pre-bulk-approval.guard';
const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    canActivate: [authGuard]

  },
  {
    path: '',
    redirectTo: 'products',
    pathMatch: 'full',


  },
  {
    path: 'streaming-dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [authGuard] 

  },
  {
    path: 'warner-dashboard',
    loadChildren: () => import('./pages/wdashboard/wdashboard.module').then(m => m.WDashboardPageModule),
    canActivate: [authGuard] 

  },
  {
    path: 'revenue-dashboard',
    loadChildren: () => import('./pages/rdashboard/rdashboard.module').then(m => m.RDashboardPageModule),
    canActivate: [authGuard] 

  },
  {
    path: 'products',
    loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsPageModule),
     canActivate: [authGuard] 
  },
  {
    path: 'tracks',
    loadChildren: () => import('./pages/tracks/tracks.module').then(m => m.TracksPageModule),
     canActivate: [authGuard] 

  },
  {
    path: 'videos',
    loadChildren: () => import('./pages/videos/videos.module').then(m => m.VideosPageModule),
     canActivate: [authGuard] 

  },
  {
    path: 'login',
    loadChildren: () => import('./login-prompt/login-prompt.module').then(m => m.LoginPromptPageModule)
  },
  {
    path: 'release-calender',
    loadChildren: () => import('./release-calender/release-calender.module').then(m => m.ReleaseCalenderPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'release-details',
    loadChildren: () => import('./release-details/release-details.module').then(m => m.ReleaseDetailsPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'marketing-activity-view',
    loadChildren: () => import('./marketing-activity-view/marketing-activity-view.module').then(m => m.MarketingActivityViewPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'marketing-activity-add-edit',
    loadChildren: () => import('./marketing-activity-view/marketing-activity-add-edit/marketing-activity-add-edit.module').then(m => m.MarketingActivityAddEditPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'campaign-projection',
    loadChildren: () => import('./marketing-activity-view/campaign-projection/campaign-projection.module').then(m => m.CampaignProjectionPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'projection-vs-actual',
    loadChildren: () => import('./marketing-activity-view/projection-vs-actual/projection-vs-actual.module').then(m => m.ProjectionVsActualPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'takedown',
    loadChildren: () => import('./pages/takedown/takedown.module').then(m => m.TakedownPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'ddex-delivery',
    loadChildren: () => import('./pages/ddex-delivery/ddex-delivery.module').then(m => m.DdexDeliveryPageModule),
    canActivate: [authGuard]
  },
  // {

  //   path: 'partner-management/:id',
  //   loadChildren: () => import('./pages/partner-management/partner-management.module').then( m => m.PartnerManagementPageModule)
  // },
  {
    path: 'partner-management',
    loadChildren: () => import('./pages/partner-management/partner-management.module').then(m => m.PartnerManagementPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'partner-management/:id',
    loadChildren: () => import('./pages/partner-management/partner-management.module').then(m => m.PartnerManagementPageModule),
    canActivate: [authGuard]
  },

  {
    path: 'partner-view',
    loadChildren: () => import('./pages/partner-view/partner-view.module').then(m => m.PartnerViewPageModule),
    canActivate: [authGuard]
  },

  {

    path: 'takedown-logs',
    loadChildren: () => import('./takedown-logs/takedown-logs.module').then(m => m.TakedownLogsPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'legal-noc',
    loadChildren: () => import('./pages/legal-noc/legal-noc.module').then(m => m.LegalNocPageModule),
    canActivate: [authGuard]
  },

  {
    path: 'published-track',
    loadChildren: () => import('./pages/published-track/published-track.module').then(m => m.PublishedTrackPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'tips-video-library',
    loadChildren: () => import('./pages/tips-video-library/tips-video-library.module').then(m => m.TipsVideoLibraryPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'product-view',
    loadChildren: () => import('./product-view/product-view.module').then( m => m.ProductViewPageModule),
    canActivate: [authGuard]
  },

  {
    path: 'admin/users',
    loadChildren: () => import('./pages/admin/user-management/user-management.module').then(m => m.UserManagementModule),
    canActivate: [authGuard]
  },

  {
    path: 'bulk-upload',
    loadChildren: () => import('./pages/bulk-upload/bulk-upload.module').then(m => m.BulkUploadPageModule),
    canActivate: [bulkUploadGuard],
  },
  {
    path: 'bulk-upload-history',
    loadChildren: () => import('./pages/bulk-upload-history/bulk-upload-history.module').then(m => m.BulkUploadHistoryPageModule),
    canActivate: [bulkUploadGuard],
  },
  {
    path: 'bulk-update',
    loadChildren: () => import('./pages/bulk-update/bulk-update.module').then(m => m.BulkUpdatePageModule),
    canActivate: [bulkUpdateGuard],
  },
  {
    path: 'bulk-approval/review',
    loadChildren: () =>
      import('./pages/bulk-approval-review/bulk-approval-review.module').then(m => m.BulkApprovalReviewPageModule),
    canActivate: [bulkApprovalGuard],
  },
  {
    path: 'bulk-approval-history',
    loadChildren: () =>
      import('./pages/bulk-approval-history/bulk-approval-history.module').then(m => m.BulkApprovalHistoryPageModule),
    canActivate: [bulkApprovalGuard],
  },
  {
    path: 'pre-bulk-approval-history',
    loadChildren: () =>
      import('./pages/pre-bulk-approval-history/pre-bulk-approval-history.module').then(m => m.PreBulkApprovalHistoryPageModule),
    canActivate: [preBulkApprovalGuard],
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {


}
